import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LeadFormRevampWrapper from "./component.js";
import { getQuestionForUserIntent } from "../lead-form/actions";

const mapStateToProps = ({
    leadData,
    user: {isLoggedIn}
}) => {
    return {
        leadData,
        isLoggedIn
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getQuestionForUserIntentConnect: getQuestionForUserIntent
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LeadFormRevampWrapper);
